import React from 'react';
import OrganizationSettingsPanel from './OrganizationSettingsPanel';
import { useAuth } from '../../../contexts/AuthContext';
import { isAdminUser } from '../../../utils/api';
import { Navigate } from 'react-router-dom';
import { Heading } from '../../ui/heading';

const FeaturesVisibilitySettingsPage: React.FC = () => {
  const { user } = useAuth();

  if (!isAdminUser(user)) {
    return <Navigate to="/v4/records" replace />;
  }

  return (
    <div className="h-full px-4 py-5 md:px-6 md:py-6">
      <div className="mb-6">
        <Heading level={2} className="font-jakarta text-2xl font-extrabold tracking-[-0.02em] text-foreground">
          Features and visibility
        </Heading>
        <p className="mt-2 max-w-2xl text-[13px] text-muted-foreground">
          Control organization-level capabilities that change how intelligence features are made available across your workspace.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6">
        <OrganizationSettingsPanel mode="features" title="Organization features" />
      </div>
    </div>
  );
};

export default FeaturesVisibilitySettingsPage;
